import { useQuery } from 'data-fetching-client';
import { FETCH_SMS_FROM_ROOT_MIC_ID } from '../queries/fetchSmsCrmObject';
const useFetchSmsCrmObject = ({
  rootMicId
}) => {
  const {
    data: smsCrmObjectResponse,
    loading: fetchSmsLoading,
    error: fetchSmsError
  } = useQuery(FETCH_SMS_FROM_ROOT_MIC_ID, {
    variables: {
      rootMicId
    }
  });
  if (smsCrmObjectResponse && smsCrmObjectResponse.smsObject && smsCrmObjectResponse.smsObject.results) {
    return {
      smsCrmObject: smsCrmObjectResponse.smsObject.results[0],
      loading: fetchSmsLoading,
      error: !!fetchSmsError
    };
  }
  return {
    smsCrmObject: undefined,
    loading: fetchSmsLoading,
    error: !!fetchSmsError
  };
};
export default useFetchSmsCrmObject;